import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";
import { PayloadRequest } from "Pages/PGX/Interpretation/Types";

export const getAllData = (parameter: PayloadRequest) => {
  return HttpClient().post(
    `${apiRoutes.PGXLis.Interpretation.GetAll}`,
    parameter
  );
};

export const Reject = (payload: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.Interpretation.Reject}`,
    payload
  );
};

export const Approve = (
  payload: { requisitionOrderId: number; requisitionId: number }[]
) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.Interpretation.BulkPublishAndValidate}`,
    payload
  );
};

export const UnApprove = (payload: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.Interpretation.UnPublishAndUnValidate}`,
    payload
  );
};

export const BulkReRunPGxLISOrders = (reqOrderIds: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.Interpretation.BulkReRunPGxLISOrders}`,
    { reqOrderIds }
  );
};

export const BulkReSendPGxLISOrders = (reqOrderIds: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.Interpretation.BulkReSendPGxLISOrders}`,
    { reqOrderIds }
  );
};
